module.exports = __webpack_public_path__ + "img/helpExaminationsS.f90075e7.svg";